import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"fill-height text-left d-flex flex-column dsfr",attrs:{"outlined":""}},[_c(VCardTitle,{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.concerns.title)+" ")]),_c(VCardSubtitle,{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.concerns.description)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }